var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-7",attrs:{"id":_vm.id}},[_c('div',{staticClass:"capitalize font-bold text-lg border-b-2 mb-5"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }